import React from 'react';
import { Content, Button, Text } from '@leverege/ui-elements';
import S from './Style.css';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function Confirmation(props) {
  const {
    zones,
    vehicles,
    setConfirmed,
    startDelete,
    onClose
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Content.Area, {
      variant: "dialogBody",
      layout: "flex:col",
      className: S.container,
      children: /*#__PURE__*/_jsxs(Text, {
        variant: "body",
        children: ["Are you sure you want to reset this location? It will delete ", zones?.length || 0, " zones and ", vehicles?.length || 0, " vehicles."]
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      variant: "dialogFooter",
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "secondary",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setConfirmed(true);
          startDelete();
        },
        variant: "primaryDestructive",
        children: "Reset"
      })]
    })]
  });
}
export default Confirmation;